@import 'apps/webcomponents/src/assets/fonts.scss';


:host {
  border-right: 1px solid var(--chart-101-pressed-dividers);
  background-color: var(--grey-layout-020-side-panel-background);
  padding: calc(5 * var(--spacer)) 0 0 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: 100%;
  font-family: inherit;
  scrollbar-width: thin;
  scrollbar-color: var(--chart-104-pressed) var(--white-layout-302-level-1-elevation);

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: var(--white-layout-300-primary);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--chart-300-icon-buttons);
    border-radius: 6px;
  }
}

.no-results {
  text-align: center;
  gz-text {
    --font-family: var(--font-family-secondary);
  }
}

.group-title {
  color: var(--chart-302-icon-buttons-titles);
  height: calc(5 * var(--spacer));
  display: flex;
  align-items: center;
  padding: 0 calc(2 * var(--spacer));
}

.panel-list-item {
  font-size: var(--body-size-large);
  font-family: var(--font-family-secondary);
  height: calc(5 * var(--spacer));
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border: 1px solid transparent;
  color: var(--main-titles-inputs-600);

  &.is-node {
    padding: var(--node-item-padding);
  }

  &.is-leaf {
    padding: var(--leaf-item-padding);
  }

  &.content-item {
    background-color: var(--grey-layout-020-side-panel-background);
    &:hover {
      background-color: var(--chart-050-hover);
    }

    &:active {
      background-color: var(--blue-layout-103-background);
    }

    &:focus-visible {
      outline: none;
      border-color: var(--blue-layout-500-focus);
    }

    &.active {
      background-color: var(--blue-layout-103-background);
    }
  }
}

.panel-group:not(:last-of-type) {
  position: relative;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    height: 1px;
    width: calc(100% - 32px);
    background-color: var(--chart-104-pressed);
    left: calc(2 * var(--spacer));
  }
}

gz-collapsible-panel {
  --panel-content-padding: 0;

  &::part(header-slot) {
    width: 100%;
  }

  &::part(panel-header) {
   column-gap: var(--spacer);
  }

  &[hideToggle] {
    --leaf-item-padding: 0 calc(2 * var(--spacer)) 0 calc(4 * var(--spacer));
  }
}

.side-menu {
  &--header {
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 calc(2 * var(--spacer));
  }

  &--nav-list {
    overflow-y: scroll;
  }
}
